import forEach from "lodash/forEach";
import trim from "lodash/trim";
import isEmail from "validator/lib/isEmail";
import isNumeric from "validator/lib/isNumeric";

import PollConfig from "./PollConfig";
import store from "../store";
import { saveState, saveValue } from "../utils/poolTools";

const validate = values => {
  // console.log("validating");
  // const { pageNum } = props;
  const pollConfig = new PollConfig();
  const pages = pollConfig.getPages();

  const errors = {};
  pages.map((page, index) => {
    const config = new PollConfig().getQuestions(index);
    config.map(question => {
      const { options } = question;
      const { required } = options;
      const key = question.getId();
      const actualValue = values[key];
      if (required) {
        if (typeof actualValue === "undefined")
          errors[key] = "Proszę uzupełnić pole";
        else if (options.type === "checkbox") {
          if (!actualValue) {
            errors[key] = "Pole musi byż zaznaczone, aby móc kontynuować";
          }
        } else if (
          (options.type === "text" || options.type === "select") &&
          actualValue.trim().length === 0
        ) {
          errors[key] = "Proszę uzupełnić pole";
        }
      }
      // jesli jeszce nie bylo bledu, a jest jakas wartrosc , przejdz przez kolejne walidacje
      if (!errors[key]) {
        forEach(options.validations, (vValue, vKey) => {
          if (actualValue) {
            if (vKey === "isEmail" && typeof actualValue !== "undefined")
              if (
                !isEmail(actualValue.trim(), {
                  allow_display_name: false,
                  require_display_name: false,
                  allow_utf8_local_part: false,
                  require_tld: true
                })
              )
                errors[key] = "Podany adres e-mail jest nieprawidłowy";

            if (vKey === "minLength" && typeof actualValue !== "undefined")
              if (trim(actualValue).length < vValue)
                errors[
                  key
                ] = `Wpis zbyt krótki. Podaj co najmniej ${vValue} znaków`;

            if (vKey === "maxLength" && typeof actualValue !== "undefined")
              if (trim(actualValue).length > vValue)
                errors[
                  key
                ] = `Wpis zbyt długi. Podaj nie więcej niż ${vValue} znaków`;

            if (vKey === "isNumeric" && typeof actualValue !== "undefined")
              if (!isNumeric(actualValue))
                errors[key] = "Proszę podać wartość liczbową";
            if (vKey === "isPhone" && typeof actualValue !== "undefined") {
              if (!actualValue.match(/^\d{9}$/))
                errors[key] =
                  options.validations.isPhoneMsg ||
                  "Proszę podać numer telefonu. Dozwolone są jedynie cyfry, spacje i myślnik";
            }

            if (vKey === "higherThan" && typeof actualValue !== "undefined")
              if (parseInt(actualValue, 10) - 1 < vValue)
                errors[key] =
                  options.validations.higherThanMsg ||
                  "Proszę podać poprawną wartość";

            if (vKey === "lowerThan" && typeof actualValue !== "undefined")
              if (parseInt(actualValue, 10) + 1 > vValue)
                errors[key] =
                  options.validations.lowerThanMsg ||
                  "Proszę podać poprawną wartość";
          } else if (
            vKey === "requireIfNotExists" &&
            (actualValue || "").trim().length === 0
          ) {
            if ((values[vValue.field] || "").trim().length === 0)
              errors[key] = vValue.message;
          } else if (vKey === "requireIfNotTrue" && !actualValue) {
            if (!values[vValue.field]) errors[key] = vValue.message;
          }

          if (errors[key]) return false; // break
          return true;
        });
      }
      return null;
    });
    return null;
  });

  saveState("poll-formValues", values);
  const realFormPage = store.getState().poll.page || 0;
  saveValue("poll-form", "page", realFormPage);
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/utils/validate.js